// Epoch changes even for A → B → A: late responses never belong to the new visit.
let epoch = 0;
export const tenantEpoch = () => epoch;
export const advanceTenantEpoch = () => ++epoch;
